module.exports = __webpack_public_path__ + "static/img/rz(2).5ceac878.png";